import React, { useState } from "react";
import { Helmet } from "react-helmet";
import GenerateHomePageLinks from "../HomePageLinks/HomePageLinks";
import { MASTER_JOB_LABELS } from "../config/masterJobsApi";

const admitCardTips = [
  "Match your name, exam date, reporting time, and center details correctly.",
  "Read the instructions on the admit card before exam day.",
  "Carry only the allowed documents and identity proof listed in the notice.",
];

const AdmitCardPage = () => {
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <div className="page-container">
      <Helmet>
        <title>{`Free Admit Card Updates ${new Date().getFullYear()} | AAMSchool`}</title>
        <link rel="canonical" href="https://www.aamschool.in/admit-card" />
        <meta
          name="description"
          content="Check free admit card updates, exam hall ticket notices, and related candidate alerts on AAMSchool."
        />
        <meta property="og:title" content={`Free Admit Card Updates ${new Date().getFullYear()} | AAMSchool`} />
        <meta
          property="og:description"
          content="Check free admit card updates, exam hall ticket notices, and related candidate alerts on AAMSchool."
        />
        <meta property="og:url" content="https://www.aamschool.in/admit-card" />
        <meta property="og:type" content="website" />
      </Helmet>
      <h1>Admit Card {new Date().getFullYear()}</h1>
      <p className="page-lead">
        This section helps users find recent admit card updates quickly. Before the exam, always
        read the complete instructions so you understand timing, document rules, and exam center
        requirements.
      </p>

      <div className="search-container">
        <input
          type="text"
          placeholder="Search jobs, admit card, result..."
          className="global-search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <GenerateHomePageLinks
        label={MASTER_JOB_LABELS.admitCards}
        header="Latest Admit Cards"
        searchTerm={searchTerm}
        showAllItems
        layoutVariant="page"
      />

      <section className="page-info-grid" aria-label="Admit card guidance">
        <article className="page-info-card">
          <h2>Before Downloading</h2>
          <ul className="page-info-list">
            {admitCardTips.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </article>
        <article className="page-info-card">
          <h2>Important Reminder</h2>
          <p>
            Admit card information should always be checked on the official website. Use this page
            to discover the update quickly, then confirm the final details from the issuing board
            or recruitment authority.
          </p>
        </article>
      </section>
    </div>
  );
};

export default AdmitCardPage;
